import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box, Button, Divider,
    Link, List, ListItem, ListItemIcon, ListItemText,
    Paper,
    Stack,
    TextField,
    Typography
} from "@mui/material";
import {useMainContext} from "../constants";
import {AccessTime, AttachMoney, CalendarMonth, ExpandMore, Groups, HealthAndSafety, Place} from "@mui/icons-material";
import CodeOfConduct from "../CodeOfConduct";
import Eligibility from "../Eligibility";

export default function SoccerHome() {

    const { mainVariant, smallVariant, smallerVariant, smallestVariant } = useMainContext();

    return (
        <Box sx={{ maxWidth: 'lg',
            paddingTop: { xs: "10px", sm: "15px", md: "20px"},
            paddingLeft: { xs: "10px", sm: "20px", md: "30px"},
            paddingRight: { xs: "10px", sm: "20px", md: "30px"},
            paddingBottom: { xs: "10px", sm: "20px", md: "30px"},
            marginLeft: "auto", marginRight: "auto" }}>
            <Stack direction="column" spacing={2}>

                <Link className="light" href="https://register.teamsnap.com/form/5IRo68VZG4iEB8hL1F9fK" target="_blank" rel="noopener" underline="always">2026 Fall Registration</Link>

                <Typography variant="h5" component="h1" gutterBottom sx={{ fontWeight: 'bold'}}>
                    Rochester Rapids Soccer
                </Typography>

                <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem' }}>
                    The Rochester Rapids offer competitive soccer for homeschooled boys and girls (5th–12th grade).
                    Our program focuses on athletic development and sportsmanship through local league play
                    and regional and national tournaments.
                </Typography>

                <List>
                    <ListItem disablePadding sx={{ mb: 1 }}>
                        <ListItemIcon sx={{ minWidth: 40 }}><Groups /></ListItemIcon>
                        <ListItemText
                            primary={<Typography variant="body1"><strong>Teams:</strong> Co-ed Modified (Ages 10–14) and Varsity (Ages 15–18)</Typography>}
                        />
                    </ListItem>
                    <ListItem disablePadding sx={{ mb: 1 }}>
                        <ListItemIcon sx={{ minWidth: 40 }}><CalendarMonth  /></ListItemIcon>
                        <ListItemText
                            primary={<Typography variant="body1"><strong>Season:</strong> Early August through late October</Typography>}
                        />
                    </ListItem>
                    <ListItem disablePadding sx={{ mb: 1 }}>
                        <ListItemIcon sx={{ minWidth: 40 }}><AccessTime /></ListItemIcon>
                        <ListItemText
                            primary={<Typography variant="body1"><strong>Schedule:</strong> Tuesdays, Thursdays, and Saturdays</Typography>}
                        />
                    </ListItem>
                    <ListItem disablePadding sx={{ mb: 1 }}>
                        <ListItemIcon sx={{ minWidth: 40 }}><Place /></ListItemIcon>
                        <ListItemText
                            primary={
                                <Typography variant="body1">
                                    <strong>Location:</strong> Practices and home games at {' '}
                                    <Link className="light" href="https://gandtathletics.info/sportspark/" target="_blank" rel="noopener" underline="always">
                                        Grace and Truth Sports Park
                                    </Link>
                                </Typography>
                            }
                        />
                    </ListItem>
                    <ListItem disablePadding sx={{ mb: 1 }}>
                        <ListItemIcon sx={{ minWidth: 40 }}>< AttachMoney /></ListItemIcon>
                        <ListItemText
                            primary={<Typography variant="body1"><strong>Cost:</strong> $165 per player plus uniforms</Typography>}
                        />
                    </ListItem>
                    <ListItem disablePadding sx={{ mb: 1 }}>
                        <ListItemIcon sx={{ minWidth: 40 }}>< HealthAndSafety /></ListItemIcon>
                        <ListItemText
                            primary={<Typography variant="body1"><strong>Insurance:</strong> LEAH membership is required for insurance purposes</Typography>}
                        />
                    </ListItem>
                </List>

                <Typography variant="body2" sx={{paddingBottom: "20px"}}>
                    Questions? Contact our Soccer Coordinator, <strong>Irv Salisbury</strong>, at{' '}
                    <Link className="light" href="mailto:irv.salisbury@gmail.com">irv.salisbury@gmail.com</Link> or{' '}
                    <Link className="light" href="tel:5857665103">(585) 766-5103</Link>.
                </Typography>

                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMore/>} data-testid="soccerGeneralSchedule">
                        <Typography variant={smallestVariant}>General Schedule</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography variant="body1">
                            <div><span style={{fontWeight: "bold"}}>Practices: August</span>
                            </div>
                            <ul>
                                <li>Official practices start 2nd week of August</li>
                                <li>Tuesday and Thursday from 5:30-7:30pm, Saturdays 1-3pm</li>
                            </ul>
                            <div><span style={{fontWeight: "bold"}}>Season: September-October</span>
                                </div>
                            <ul>
                                <li>Away games on Tuesdays, home games on Thursdays</li>
                                <li>Game time dependent on team</li>
                                <li>Practices on Saturdays from 1-3pm</li>
                                <li>Playoffs and Tournaments end of October</li>
                            </ul>
                            <div><span style={{fontWeight: "bold"}}>Winter Season: January-March</span>&nbsp;
                                <span>(Optional)</span></div>
                            <ul>
                                <li>Saturday evenings at <Link className="light"
                                                               href="https://maps.app.goo.gl/246JyGZzjgYAxovF6">Empire
                                    Facility</Link></li>
                                <li>Practice time depends on team</li>
                            </ul>
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMore/>} data-testid="soccerFaq">
                        <Typography variant={smallestVariant}>Frequently Asked Questions</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography variant="body1" sx={{fontWeight: "bold", marginBottom: "3px"}}>Do you have any
                            cuts?</Typography>
                        <Typography variant="body1">
                            We try to make sure every home educated player has the ability to play with Rapids Soccer if
                            they want to.
                            At the Modified level, we do not have any cuts and divide up the players into even teams
                            based
                            on number of registrations. At the Varsity level, we do not have cuts, but if the registered
                            number of players does not divide well into teams, we will occasionally have pool players
                            who
                            are able to practice and play in our non competitive games. This is a year by year decision.
                        </Typography>
                        <Typography variant="body1" sx={{fontWeight: "bold", marginTop: "15px", marginBottom: "3px"}}>How
                            competitive is the program?</Typography>
                        <Typography variant="body1">
                            The modified level has all levels of players, and we adjust practices to handle all
                            different
                            skill levels. The players will be divided into equal teams for the season. At the Varsity
                            level we have both Tournament teams that are very competitive and league teams that are less
                            competitive. We have handled all different skill levels on the Varsity. We are not a
                            "recreation"
                            program, and the players will be expected to practice accordingly.
                        </Typography>
                        <Typography variant="body1" sx={{fontWeight: "bold", marginTop: "15px", marginBottom: "3px"}}>Playing
                            Time</Typography>
                        <Typography variant="body1">
                            At the modified level, we do our best to play everyone at least half of the game. This will
                            all be based on numbers who are on the teams and show up for the games. On Varsity, there
                            is no guarantee of playing time. At the league team level we have games that are less
                            competitive and we do our best to get everyone good playing time in those games. When games
                            are more competitive at the Varsity level, no playing time is guaranteed.
                        </Typography>
                        <Typography variant="body1" sx={{fontWeight: "bold", marginTop: "15px", marginBottom: "3px"}}>How
                            far do you travel for games?</Typography>
                        <Typography variant="body1">
                            The modified teams mostly play within the greater Rochester area, but there are one or two
                            teams that are about an hour away.
                            The Varsity league teams play mostly within an hour of Rochester, but also play a team from
                            Elmira. There is one tournament in Binghamton.
                            The Varsity tournament teams play one tournament in Fort Wayne Indiana, have one trip to
                            Michigan, and play in the Nationals in Tennessee.
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <CodeOfConduct/>
                <Eligibility/>
            </Stack>
        </Box>
    )
}
